<template>
  <div>
    <div class="no-users" v-if="data.length === 0">
      <h3 class="no-users-text">
        No Hay Usuarios Registrados en Este Servicio.
      </h3>
    </div>
    <table v-else class="table">
      <thead class="head">
        <slot name="columns">
          <th class="head-text" v-for="column in columns" :key="column">
            <div class="some">
              {{ column }}
            </div>
          </th>
          <!-- <th></th> -->
        </slot>
      </thead>
      <tbody v-if="routeServiceId !== 31">
        <tr v-for="(item, index) in data" :key="index">
          <td class="text-ne">
            {{ formatName(item) }}
          </td>
          <td class="run">
            {{ item.run }}
          </td>
          <td class="text-ne">
            {{ item.email }}
          </td>
          <td class="text-paam">
            <!-- {{index}} -->
            {{ showPerfil(item) }}
          </td>
          <td class="text-paam">
            {{ listPerms(item) }}
          </td>
          <slot name="actions" :item="item"> </slot>
        </tr>
      </tbody>
      <tbody v-else>
        <tr v-for="(item, index) in data" :key="index">
          <td class="text-ne">
            {{ formatName(item) }}
          </td>
          <td class="run">
            {{ item.run }}
          </td>
          <td class="text-ne">
            {{ item.email }}
          </td>
          <slot name="adminActions" :item="item"> </slot>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { formatRole, formatPerm } from "../../components/tools/utils";
export default {
  name: "paper-table",
  props: ["columns", "data"],
  data() {
    return {
      routeServiceId: this.$route.params.idServicio,
      perfil: "",
      adminName: process.env.VUE_APP_USER_ADMIN,
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
  },
  methods: {
    showPerfil: function(user) {
      return formatRole(user.rol.nombre);
    },
    formatName: function(obj) {
      return (obj.firstName + " " + obj.lastName).length !== 1
        ? obj.firstName + " " + obj.lastName
        : obj.username;
    },
    darFormatoPerm(name) {
      return formatPerm(name);
    },
    listPerms(obj) {
      if ([1, 2, 3, 4, 6].includes(obj.rol.id)) {
        return "No Aplica";
      } else {
        return obj.permisos[0][0]
          ? obj.permisos[0]
              // .map((p) => this.darFormatoPerm(p.nombre))
              .map((p) => p.nombre)
              .filter(p=>{return p.indexOf("anexo")>=0})
              .join(" / ")
          : "Sin Módulos Asignados";
      }
    },
  },
};
</script>

<style>
.head {
  background: #e0e0e0;
}
.head-text {
  color: #052333;
  height: 40px;
}
.some {
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-users {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30vh;
  background: #efefef;
}

.no-users-text {
  font-weight: bold;
}

.table {
  --bs-table-striped-bg: #c8f1ea !important;
}
.table > :not(caption) > * > * {
  border-bottom-width: 0 !important;
}

.text-ne {
  font-weight: bold;
  text-decoration: underline;
  font-size: 0.9rem !important;
}

.run {
  font-weight: bold;
  color: #24c6ab !important;
  font-size: 1rem !important;
}

.text-paam {
  font-weight: 200;
  font-size: 0.9rem !important;
  max-width: 20vw;
}

th {
  font-size: 20px;
  text-align: center !important;
}

tr {
  text-align: center !important;
}

td {
  color: #052333 !important;
}

tbody {
  background: #f5f5f5;
}

tr:hover {
  background: rgba(0, 255, 247, 0.2);
}

@media screen and (max-width: 674px) {
  th {
    font-size: 14px !important;
    text-align: initial !important;
  }
  td {
    font-size: 11px !important;
    text-align: initial !important;
  }
  table {
    width: 80%;
  }
}

@media screen and (max-width: 500px) {
  th {
    font-size: 12px !important;
  }

  td {
    font-size: 8px !important;
  }

  table {
    width: 80%;
  }
}

@media screen and (max-width: 400px) {
  th {
    font-size: 7px !important;
  }

  td {
    font-size: 3px !important;
  }

  table {
    width: 50%;
  }
}

/* .paginationButton {
  border-radius: 100% !important;
  margin-right: 3.5px;
  line-height: 22px !important;
  font-size: 14px !important;
  border: 2px solid #66615b !important;
}
.paginationButton:hover {
  background: #66615b !important;
  color: white !important;
}
.paginationNoSelected {
  background: white !important;
  color: #66615b !important;
}
.icon {
  font-size: 11px;
} */
</style>
